import ReportController from './report.controller';

export default class AirlineReportController extends ReportController
{
	get endpoint() {
		return 'airline';
	}

	get title() {
		return 'Airline Report';
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/airline.report.controller.js
 **/